import LogtoClient, { UserScope } from "@logto/browser";

const { REACT_APP_LOGTO_APPID, REACT_APP_LOGTO_ENDPOINT } = process.env;

export const logtoClient = new LogtoClient({
  endpoint: REACT_APP_LOGTO_ENDPOINT as string,
  appId: REACT_APP_LOGTO_APPID as string,
  scopes: [
    UserScope.CustomData,
    UserScope.Email,
    UserScope.Organizations,
    "read:contract",
    "read:contract",
    "read:claims",
    "read:pending-contract",
    "create:bulk-contract",
    "create:ticket",
    "cancel:contract",
    "create:contract",
  ],
});
